var FeedVisibility;
(function (FeedVisibility) {
    FeedVisibility["JUST_ME"] = "private";
    FeedVisibility["MY_FEED"] = "teams";
    FeedVisibility["EVERYTHING"] = "";
})(FeedVisibility || (FeedVisibility = {}));
export default FeedVisibility;
